import moment from 'moment';
import _ from 'lodash';
import {
    mapGetters
} from 'vuex';

export default {
    data() {
        return {
            /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
            queryParam: {},

            pickerOptions: {
                shortcuts: [{
                    text: "最近一周",
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit("pick", [start, end]);
                    }
                },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一年",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            /* 数据源 */
            dataSource: [],
            /* 数据总数 */
            total: 0,
            /* 分页 */
            pagintion: {
                page: 1,
                page_size: 10
            },
            /* 选中数据 */
            rowKeySelection: [],
            /* 选中数据项 */
            rowSelection: [],
            /* 列表的加载方法 */
            fetchDataEvent: null,
            /* 禁用初始化 */
            disabledCreated: false,
            /* 是否自动触发搜索 */
            autoSearch: true,
            // 需要合并的键值
            mergeKeys: [],
            rowKey: 'id',
            loadCallBack: null,
            // 删除配置
            deleteConfig: {
                title: '删除', // 标题
                content: '是否确认删除？删除后数据不可恢复！',
                url: "",
                paramsKey: 'id',
                paramsType: 'string', // 删除参数类型
            },
            timeRange: [],
            exportDataEvent: null
        }
    },
    created() {
        if (!this.disabledCreated) {
            if (!this.$route.meta.keepAlive) {
                this.loadData();
            }
        }
    },
    activated() {
        // 页面主动接管首屏加载时，keep-alive 激活也不能再补打列表请求。
        if (this.disabledCreated) {
            return;
        }
        if (this.$route.meta.keepAlive) {
            this.loadData();
        }
    },
    computed: {
        ...mapGetters(["com_list"])
    },
    filters: {
        timeFormat(time, style = 'YYYY-MM-DD HH:mm:ss') {
            return time ? moment.unix(time).format(style) : '--'
        }
    },
    methods: {
        async loadData() {
            if (this.fetchDataEvent) {
                try {
                    this.dataSource = [];
                    this.total = 0;
                    const dataObj = await this.fetchDataEvent(Object.assign(this.queryParam, this.pagintion));
                    const {
                        total,
                        data,
                        current_page,
                        last_page
                    } = dataObj.data.data;
                    if (current_page > last_page) {
                        this.pagintion.page = last_page;
                        this.loadData();
                    } else {
                        this.dataSource = data;
                        this.total = total;
                    }
                } catch (e) {

                }
                setTimeout(() => {
                    if (this.loadCallBack) {
                        this.loadCallBack();
                    }
                }, 500);

            }
        },
        refreshData() {
            this.rowKeySelection = [];
            this.rowSelection = [];
            this.loadData();
        },
        onReset() {
            this.pagintion.page = 1;
            this.timeRange = [];
            this.queryParam = {};
            this.onSearch();
        },
        onSearch() {
            this.rowKeySelection = [];
            this.rowSelection = [];
            this.pagintion.page = 1;
            this.loadData();
        },
        // row：当前行数据，state：是否单个删除
        onDelete(row, state) {
            if (!state) {
                if (this.rowKeySelection.length === 0) {
                    this.$message.warning("请选择要删除的数据！");
                    return;
                }
            }
            this.$confirm(this.deleteConfig.content, this.deleteConfig.title)
                .then(async () => {
                    if (state) {
                        this.$common.http({
                            url: this.deleteConfig.url,
                            data: {
                                [this.deleteConfig.paramsKey]: this.deleteConfig.paramsType === 'array' ? [row.id] : row.id
                            }
                        }).then(() => {
                            this.$common.pcToastSuccess(`操作成功`);
                            this.onSearch();
                        });
                    } else {
                        try {
                            if (this.deleteConfig.paramsType === 'array') {
                                await this.$common.http({
                                    url: this.deleteConfig.url,
                                    data: {
                                        [this.deleteConfig.paramsKey]: this.rowKeySelection
                                    }
                                })
                            } else {
                                const reqs = this.rowKeySelection.map((id) => {
                                    return this.$common.http({
                                        url: this.deleteConfig.url,
                                        data: {
                                            [this.deleteConfig.paramsKey]: id
                                        }
                                    })
                                });
                                await Promise.all(reqs);
                                this.$common.pcToastSuccess(`操作成功`);
                            }
                            this.onSearch();
                        } catch (error) {
                            console.log(error);
                        }
                    }
                })
                .catch(_ => {
                });
        },
        async onExport() {
            if (this.exportDataEvent) {
                try {
                    this.$common.pcToastLoading('正在导出0.00%...');
                    const export_task_resp = await this.exportDataEvent(this.queryParam);
                    const {
                        task_id
                    } = export_task_resp.data.data;
                    this.$common.http({
                        url: '/api/cron/imexport',
                        noLoading: true,
                        retuenReject: true,
                        timeout: e=>{
                            console.error(e);
                        }
                    });
                    this.getImexportProgress(task_id).then(({result, remark}) => {
                        function downloadFunc() {
                            const a = document.createElement('a');
                            a.href = result.download_url;
                            a.style.display = 'none';
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }

                        this.$common.pcToastClose();
                        if (result === '[]' && remark) {
                            this.$common.pcToastFail(remark);
                        } else {
                            // downloadFunc();
                            this.$confirm("导出成功，请点击下载", "提示", {
                                showClose: false,
                                cancelButtonText: "关闭",
                                confirmButtonText: "下载",
                                closeOnPressEscape: false,
                                closeOnClickModal: false,
                                beforeClose: (action, instance, done) => {
                                    if (action === 'confirm') {
                                        downloadFunc();
                                    } else {
                                        done();
                                    }
                                }
                            }).then(downloadFunc);
                        }
                    });
                } catch (error) {
                    this.$common.pcToastClose()
                }
            }
        },
        getImexportProgress(task_id) {
            return new Promise((resolve, reject) => {
                const progressFunc = async () => {
                    try {
                        const res = await this.$common.http({
                            url: "/api/queue/admin/get_imexport_progress",
                            data: {
                                task_id
                            },
                            noLoading: true
                        });
                        const {
                            finish,
                            percent,
                            remark,
                            result
                        } = res.data.data;
                        this.$common.pcToastLoadingUpdate(`正在导出 ${percent}%...`, 1);
                        if (finish === 1) {
                            resolve({result, remark});
                        } else {
                            setTimeout(() => {
                                progressFunc();
                            }, 1000);
                        }
                    } catch (error) {
                        reject(error);
                    }
                }
                progressFunc();
            })
        }
    },
    components: {},
    watch: {
        queryParam: {
            deep: true,
            handler: _.debounce(function () {
                if (this.autoSearch) {
                    this.onSearch();
                }
            }, 300)
        },
        timeRange: {
            deep: true,
            handler: function (val) {
                if (val && val.length === 2) {
                    this.queryParam.begin_time = moment(val[0]).format('X');
                    this.queryParam.end_time = moment(val[1]).format('X');
                } else {
                    this.queryParam.begin_time = null;
                    this.queryParam.end_time = null;
                }
                if (this.autoSearch) {
                    this.onSearch();
                }
            }
        }
    }
}
